'use client'

import { usePathname } from 'cf-menu/hooks/use-path-name'

export const TicketGenieSnippetWrapper = ({
  children,
  blacklistPathPrefixes,
  locale,
}: React.PropsWithChildren<{ blacklistPathPrefixes?: string[]; locale: string }>) => {
  const pathname = usePathname()

  const shouldHide =
    blacklistPathPrefixes &&
    blacklistPathPrefixes.some(blacklistPath =>
      locale === 'en'
        ? pathname.startsWith(blacklistPath)
        : pathname.startsWith(`/${locale}${blacklistPath}`),
    )

  if (shouldHide) {
    return null
  }

  return children
}
